import {
  ANNUAL_LEAVE_OVERVIEW_SCREEN,
  DATE_FORMAT_V2,
  FILTER_KEY_APPLY_DATE,
  FILTER_KEY_DEPARTMENT,
  FILTER_KEY_DIVISION,
  FILTER_KEY_EMPLOYEE,
  FILTER_KEY_EXPIRE_DATE,
  FILTER_KEY_ONBOARD_DATE,
  FILTER_KEY_PROJECT,
  FILTER_KEY_ROLE,
  FILTER_KEY_TIME_SHEET,
  FILTER_KEY_WORK_SCHEDULE_CODE,
  FILTER_KEY_WORK_SCHEDULE_TYPE,
  FILTER_TYPE_AUTO_COMPLETE,
  FILTER_TYPE_BUTTON,
  FILTER_TYPE_DATE_RANGE,
  FILTER_TYPE_INPUT,
  FILTER_TYPE_MULTIPLE_SELECT,
  FILTER_TYPE_SELECT,
  LEAVE_CARRYOVER_SCREEN,
  POLICY_CONFIG_WORK_SCHEDULE_CONFIG_SCREEN,
  POLICY_MANAGEMENT_DEPARTMENT_SCREEN,
  POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN,
  POLICY_MANAGEMENT_EMPLOYEE_SCREEN,
  PROJECT_LEAVE_SCREEN,
  REPORT_POLICY_MAPPING_SCREEN,
} from "./constants";

// constant json filters
export const filtersJson = {
  [PROJECT_LEAVE_SCREEN]: [
    {
      label: "Staff",
      placeholder: "Search by name, Ldap",
      name: FILTER_KEY_EMPLOYEE,
      type: FILTER_TYPE_AUTO_COMPLETE,
    },
    {
      label: "Division",
      placeholder: "Search by Division",
      name: FILTER_KEY_DIVISION,
      type: FILTER_TYPE_MULTIPLE_SELECT,
    },
    {
      label: "Department",
      placeholder: "Search by Department",
      name: FILTER_KEY_DEPARTMENT,
      type: FILTER_TYPE_MULTIPLE_SELECT,
    },
    {
      label: "Search",
      type: FILTER_TYPE_BUTTON,
    },
  ],
  [ANNUAL_LEAVE_OVERVIEW_SCREEN]: [
    {
      label: "Payroll Period",
      placeholder: "Choose a Payroll Period",
      name: FILTER_KEY_TIME_SHEET,
      type: FILTER_TYPE_SELECT,
      width: {
        xl: 4,
        md: 5,
      },
    },
    {
      label: "Staff",
      placeholder: "Search by name, Ldap",
      name: FILTER_KEY_EMPLOYEE,
      type: FILTER_TYPE_AUTO_COMPLETE,
    },
    {
      label: "Division",
      placeholder: "Search by Division",
      name: FILTER_KEY_DIVISION,
      type: FILTER_TYPE_MULTIPLE_SELECT,
    },
    {
      label: "Department",
      placeholder: "Search by Department",
      name: FILTER_KEY_DEPARTMENT,
      type: FILTER_TYPE_MULTIPLE_SELECT,
    },
    {
      label: "Role",
      placeholder: "Role",
      name: FILTER_KEY_ROLE,
      type: FILTER_TYPE_MULTIPLE_SELECT,
      width: {
        xl: 3,
        md: 4,
      },
    },
    {
      label: "Search",
      type: FILTER_TYPE_BUTTON,
    },
  ],
  generalConfiguration: [
    {
      label: "Date Applied",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_APPLY_DATE,
      type: FILTER_TYPE_DATE_RANGE,
    },
    {
      label: "Date Expired",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_EXPIRE_DATE,
      type: FILTER_TYPE_DATE_RANGE,
    },
    {
      label: "Search",
      type: FILTER_TYPE_BUTTON,
    },
  ],
  [LEAVE_CARRYOVER_SCREEN]: [
    {
      label: "Staff",
      placeholder: "Search by name, Ldap",
      name: FILTER_KEY_EMPLOYEE,
      type: FILTER_TYPE_AUTO_COMPLETE,
    },
    {
      label: "Division",
      placeholder: "Search by Division",
      name: FILTER_KEY_DIVISION,
      type: FILTER_TYPE_MULTIPLE_SELECT,
    },
    {
      label: "Department",
      placeholder: "Search by Department",
      name: FILTER_KEY_DEPARTMENT,
      type: FILTER_TYPE_MULTIPLE_SELECT,
    },
    {
      label: "Date Applied",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_APPLY_DATE,
      type: FILTER_TYPE_DATE_RANGE,
    },
    {
      label: "Date Expired",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_EXPIRE_DATE,
      type: FILTER_TYPE_DATE_RANGE,
    },
    // {
    //   label: "Object",
    //   placeholder: "Choose Object",
    //   name: FILTER_KEY_OBJECT,
    //   type: FILTER_TYPE_SELECT,
    //   width: {
    //     xl: 3,
    //     md: 4,
    //   },
    // },
    {
      label: "Search",
      type: FILTER_TYPE_BUTTON,
      width: {
        xl: 1,
        md: 4,
      },
    },
  ],
  bonusLeave: [
    {
      label: "Staff",
      placeholder: "Search by staff name, ID",
      name: FILTER_KEY_EMPLOYEE,
      type: FILTER_TYPE_AUTO_COMPLETE,
    },
    {
      label: "Division",
      placeholder: "Search by Division",
      name: FILTER_KEY_DIVISION,
      type: FILTER_TYPE_MULTIPLE_SELECT,
    },
    {
      label: "Department",
      placeholder: "Search by Department",
      name: FILTER_KEY_DEPARTMENT,
      type: FILTER_TYPE_MULTIPLE_SELECT,
    },
    {
      label: "Date Applied",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_APPLY_DATE,
      type: FILTER_TYPE_DATE_RANGE,
    },
    {
      label: "Date Expired",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_EXPIRE_DATE,
      type: FILTER_TYPE_DATE_RANGE,
    },
    {
      label: "Search",
      type: FILTER_TYPE_BUTTON,
    },
  ],
  [POLICY_CONFIG_WORK_SCHEDULE_CONFIG_SCREEN]: [
    {
      label: "Work Schedule",
      placeholder: "Search by Work Schedule Code, Name",
      name: "filter",
      type: FILTER_TYPE_INPUT,
      width: {
        xxl: {
          span: 5,
        },
        xl: {
          span: 6,
        },
        md: {
          span: 8,
        },
      },
    },
    {
      label: "Search",
      type: FILTER_TYPE_BUTTON,
    },
  ],
  [POLICY_MANAGEMENT_EMPLOYEE_SCREEN]: [
    {
      label: "Staff",
      placeholder: "Search by staff name, ID",
      name: FILTER_KEY_EMPLOYEE,
      type: FILTER_TYPE_AUTO_COMPLETE,
      width: {
        xxl: {
          span: 4,
          order: 1,
        },
        xl: {
          span: 4,
          order: 1,
        },
        md: {
          span: 5,
          order: 1,
        },
      },
    },
    {
      label: "Division",
      placeholder: "Search by Division",
      name: FILTER_KEY_DIVISION,
      type: FILTER_TYPE_MULTIPLE_SELECT,
      width: {
        xxl: {
          span: 4,
          order: 2,
        },
        xl: {
          span: 4,
          order: 2,
        },
        md: {
          span: 5,
          order: 2,
        },
      },
    },
    {
      label: "Department",
      placeholder: "Search by Department",
      name: FILTER_KEY_DEPARTMENT,
      type: FILTER_TYPE_MULTIPLE_SELECT,
      width: {
        xxl: {
          span: 4,
          order: 3,
        },
        xl: {
          span: 4,
          order: 3,
        },
        md: {
          span: 5,
          order: 3,
        },
      },
    },
    {
      label: "Work Schedule Code",
      placeholder: "Search by Code",
      name: FILTER_KEY_WORK_SCHEDULE_CODE,
      type: FILTER_TYPE_MULTIPLE_SELECT,
      width: {
        xxl: {
          span: 4,
          order: 4,
        },
        xl: {
          span: 4,
          order: 4,
        },
        md: {
          span: 5,
          order: 4,
        },
      },
    },
    {
      label: "Work Schedule Type",
      placeholder: "Search by Type",
      name: FILTER_KEY_WORK_SCHEDULE_TYPE,
      type: FILTER_TYPE_MULTIPLE_SELECT,
      width: {
        xxl: {
          span: 4,
          order: 5,
        },
        xl: {
          span: 4,
          order: 5,
        },
        md: {
          span: 5,
          order: 6,
        },
      },
    },
    {
      label: "Search",
      type: FILTER_TYPE_BUTTON,
      width: {
        xxl: {
          span: 4,
          order: 8,
        },
        xl: {
          span: 1,
          order: 7,
        },
        md: {
          span: 4,
          order: 5,
        },
      },
    },
    {
      label: "Project",
      placeholder: "Search by Project",
      name: FILTER_KEY_PROJECT,
      type: FILTER_TYPE_MULTIPLE_SELECT,
      isHide: true,
      width: {
        xxl: {
          span: 4,
          order: 9,
        },
        xl: {
          span: 4,
          order: 9,
        },
        md: {
          span: 5,
          order: 9,
        },
      },
    },
    {
      label: "Onboard Date Range",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_ONBOARD_DATE,
      type: FILTER_TYPE_DATE_RANGE,
      isHide: true,
      width: {
        xxl: {
          span: 4,
          order: 10,
        },
        xl: {
          span: 4,
          order: 10,
        },
        md: {
          span: 5,
          order: 10,
        },
      },
    },
  ],
  [POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN]: [
    {
      label: "Work Schedule Code",
      placeholder: "Search by Code",
      name: FILTER_KEY_WORK_SCHEDULE_CODE,
      type: FILTER_TYPE_MULTIPLE_SELECT,
      width: {
        xxl: {
          span: 4,
          order: 1,
        },
        xl: {
          span: 4,
          order: 1,
        },
        md: {
          span: 5,
          order: 1,
        },
      },
    },
    {
      label: "Work Schedule Type",
      placeholder: "Search by Type",
      name: FILTER_KEY_WORK_SCHEDULE_TYPE,
      type: FILTER_TYPE_MULTIPLE_SELECT,
      width: {
        xxl: {
          span: 4,
          order: 2,
        },
        xl: {
          span: 4,
          order: 2,
        },
        md: {
          span: 5,
          order: 2,
        },
      },
    },
    {
      label: "Date Applied",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_APPLY_DATE,
      type: FILTER_TYPE_DATE_RANGE,
      width: {
        xxl: {
          span: 4,
          order: 3,
        },
        xl: {
          span: 5,
          order: 3,
        },
        md: {
          span: 5,
          order: 3,
        },
      },
    },
    {
      label: "Date Expired",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_EXPIRE_DATE,
      type: FILTER_TYPE_DATE_RANGE,
      width: {
        xxl: {
          span: 4,
          order: 4,
        },
        xl: {
          span: 5,
          order: 4,
        },
        md: {
          span: 5,
          order: 4,
        },
      },
    },
    {
      label: "Search",
      type: FILTER_TYPE_BUTTON,
      width: {
        xxl: {
          span: 1,
          order: 5,
        },
        xl: {
          span: 1,
          order: 5,
        },
        md: {
          span: 4,
          order: 5,
        },
      },
    },
  ],
  [POLICY_MANAGEMENT_DEPARTMENT_SCREEN]: [
    {
      label: "Division",
      placeholder: "Search by Division",
      name: FILTER_KEY_DIVISION,
      type: FILTER_TYPE_MULTIPLE_SELECT,
      width: {
        xxl: {
          span: 4,
          order: 2,
        },
        xl: {
          span: 4,
          order: 2,
        },
        md: {
          span: 5,
          order: 2,
        },
      },
    },
    {
      label: "Department",
      placeholder: "Search by Department",
      name: FILTER_KEY_DEPARTMENT,
      type: FILTER_TYPE_MULTIPLE_SELECT,
      width: {
        xxl: {
          span: 4,
          order: 3,
        },
        xl: {
          span: 4,
          order: 3,
        },
        md: {
          span: 5,
          order: 3,
        },
      },
    },
    {
      label: "Work Schedule",
      placeholder: "Search by Code, Name",
      name: FILTER_KEY_WORK_SCHEDULE_CODE,
      type: FILTER_TYPE_INPUT,
      width: {
        xxl: {
          span: 4,
          order: 4,
        },
        xl: {
          span: 4,
          order: 4,
        },
        md: {
          span: 5,
          order: 4,
        },
      },
    },
    {
      label: "Work Schedule Type",
      placeholder: "Search by Work Schedule Type",
      name: FILTER_KEY_WORK_SCHEDULE_TYPE,
      type: FILTER_TYPE_INPUT,
      width: {
        xxl: {
          span: 3,
          order: 5,
        },
        xl: {
          span: 4,
          order: 5,
        },
        md: {
          span: 5,
          order: 6,
        },
      },
    },
    {
      label: "Date Applied",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_APPLY_DATE,
      type: FILTER_TYPE_DATE_RANGE,
      width: {
        xxl: {
          span: 4,
          order: 6,
        },
        xl: {
          span: 4,
          order: 6,
        },
        md: {
          span: 5,
          order: 7,
        },
      },
    },
    {
      label: "Date Expired",
      placeholder: [DATE_FORMAT_V2, DATE_FORMAT_V2],
      name: FILTER_KEY_EXPIRE_DATE,
      type: FILTER_TYPE_DATE_RANGE,
      width: {
        xxl: {
          span: 4,
          order: 7,
        },
        xl: {
          span: 4,
          order: 8,
        },
        md: {
          span: 5,
          order: 8,
        },
      },
    },
    {
      label: "Search",
      type: FILTER_TYPE_BUTTON,
      width: {
        xxl: {
          span: 1,
          order: 8,
        },
        xl: {
          span: 1,
          order: 7,
        },
        md: {
          span: 4,
          order: 5,
        },
      },
    },
  ],
  [REPORT_POLICY_MAPPING_SCREEN]: [
    {
      label: "Staff",
      placeholder: "Search by staff name, ID",
      name: "employees",
      type: FILTER_TYPE_AUTO_COMPLETE,
      width: {
        xxl: {
          span: 3,
          order: 1,
        },
        xl: {
          span: 4,
          order: 1,
        },
        md: {
          span: 5,
          order: 1,
        },
      },
    },
    {
      label: "Division",
      placeholder: "Search by Division",
      name: "divisions",
      type: "multiple-select",
      width: {
        xxl: {
          span: 3,
          order: 2,
        },
        xl: {
          span: 4,
          order: 2,
        },
        md: {
          span: 5,
          order: 2,
        },
      },
    },
    {
      label: "Department",
      placeholder: "Search by Department",
      name: "departments",
      type: "multiple-select",
      width: {
        xxl: {
          span: 3,
          order: 3,
        },
        xl: {
          span: 4,
          order: 3,
        },
        md: {
          span: 5,
          order: 3,
        },
      },
    },
    {
      label: "Work Schedule Code",
      placeholder: "Search by Code",
      name: "workScheduleCodes",
      type: "multiple-select",
      width: {
        xxl: {
          span: 3,
          order: 4,
        },
        xl: {
          span: 4,
          order: 4,
        },
        md: {
          span: 5,
          order: 4,
        },
      },
    },
    {
      label: "Work Schedule Type",
      placeholder: "Search by Type",
      name: "ruleTypes",
      type: "multiple-select",
      width: {
        xxl: {
          span: 3,
          order: 5,
        },
        xl: {
          span: 4,
          order: 5,
        },
        md: {
          span: 5,
          order: 5,
        },
      },
    },
    {
      label: "Date Applied",
      placeholder: ["DD/MM/YYYY", "DD/MM/YYYY"],
      name: "applyDate",
      type: "dateRange",
      width: {
        xxl: {
          span: 3,
          order: 6,
        },
        xl: {
          span: 5,
          order: 6,
        },
        md: {
          span: 5,
          order: 6,
        },
      },
    },
    {
      label: "Date Expired",
      placeholder: ["DD/MM/YYYY", "DD/MM/YYYY"],
      name: "expireDate",
      type: "dateRange",
      width: {
        xxl: {
          span: 3,
          order: 7,
        },
        xl: {
          span: 5,
          order: 7,
        },
        md: {
          span: 5,
          order: 7,
        },
      },
    },
    {
      label: "Search",
      type: "button",
      width: {
        xxl: {
          span: 1,
          order: 8,
        },
        xl: {
          span: 1,
          order: 8,
        },
        md: {
          span: 4,
          order: 8,
        },
      },
    },
  ],
};
